<header>
    <router-link to="/">
        <div class="header-logo">
            <div class="logo">
                <img :src="logo" />
            </div>
            <h1 class="header-title">International Feedback Management</h1>
        </div>
    </router-link>
    <UserBadge />
</header>
